import { Button, Image } from 'react-bootstrap';
import { Link } from "react-router-dom"
export default function SelectedCreatePanel({ to, src, title }: { to: string, src: string, title: string }) {
    return <Button as={Link} variant='outline-primary'
        to={to} className='m-1 d-flex flex-column'>
        <Image fluid src={src} />
        <small className='mt-auto'><b>{title}</b></small>
    </Button>
}